import { IsBoolean, IsOptional, IsString } from 'class-validator';

export class CreateRegulatoryDetailsRequestDto {
    @IsOptional()
    @IsBoolean()
    qcManagesProductLifeCycle?: boolean;

    @IsOptional()
    @IsBoolean()
    qcReviewsMasterDocuments?: boolean;

    @IsOptional()
    @IsBoolean()
    qcManagesDel?: boolean;

    @IsOptional()
    @IsString()
    comments?: string;

    @IsOptional()
    @IsString()
    notes?: string;
}
